import { Form } from 'informed';
import styled from 'styled-components';

import { ButtonComponent } from '@nw/design-system/omega';

export const AuthFormSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const AuthFormContainer = styled(Form)`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AuthFormContainerButton = styled(ButtonComponent)``;

export const AuthFormSectionHeaderLogoContainer = styled.div`
  max-height: 44px;
  margin-bottom: 44px;
`;

export const AuthFormSectionHeaderLogoImg = styled.img`
  width: 100%;
  height: 100%;
  max-height: 44px;
`;

export const AuthFormSectionFooterLogoContainer = styled.div`
  max-height: 32px;
  position: absolute;
  bottom: 30px;
`;

export const AuthFormSectionFooterLogoImg = styled.img`
  width: 100%;
  max-height: 32px;
`;
